import * as React from "react";
import Breadcrumbs from "../core/Breadcrumbs";
import { Link } from "react-router-dom";
import { useState } from "react";
import OrgPicker from "../core/OrgPicker";
import ModernCard from "../core/ModernCard";
import usePromise from "../hooks/usePromise";
import { getOrgUsers } from "../../libs/organization";
import { useMemo } from "react";
import Loader from "../core/Loader";
import { getCommissionConfigs } from "../../libs/commission_calculator";
import CommissionConfigViewModal from "./CommissionConfigViewModal";
import Button from "../core/Button";

function CommissionCalculatorAdmin({ adminOrgState }) {
  const [selectedOrgId, setSelectedOrgId] = adminOrgState;

  const [users, { loading: loadingUsers }] = usePromise(
    () => getOrgUsers(selectedOrgId),
    [selectedOrgId]
  );

  const salespeople = useMemo(
    () => (users ? users.filter(u => u.roles.includes("sales")) : []),
    [users]
  );

  const [viewingConfig, setViewingConfig] = useState(null);

  const [configs, { loading: loadingConfigs }] = usePromise(() =>
    getCommissionConfigs(selectedOrgId)
  );

  return (
    <>
      <Breadcrumbs
        crumbs={[
          {
            label: "Commission Calculator",
            route: "/",
            routerLink: true,
          },
          { label: "Admin" },
        ]}
      />
      <label>Selected Org</label>
      <OrgPicker
        selectedOrgId={selectedOrgId}
        setSelectedOrgId={setSelectedOrgId}
      />
      <hr />
      <ModernCard title={"Configs"} ta="left" m="0px">
        {loadingConfigs ? (
          <Loader />
        ) : (
          <table className={"table"}>
            <thead>
              <tr>
                <th>Name</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {configs.map(config => (
                <tr key={config.id}>
                  <td>{config.name}</td>
                  <td>
                    <Button
                      color={"info"}
                      onClick={() => setViewingConfig(config)}
                    >
                      <i className="fa fa-eye" /> View
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ModernCard>
      <hr />
      <ModernCard title={"Salespeople"} ta="left" m="0px">
        {loadingUsers ? (
          <Loader />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {salespeople.map(user => (
                <tr key={user.id}>
                  <td>
                    <Link to={`/salespeople/${user.id}`}>{user.name}</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ModernCard>
      <CommissionConfigViewModal
        open={!!viewingConfig}
        close={() => setViewingConfig(null)}
        config={viewingConfig}
      />
    </>
  );
}

export default CommissionCalculatorAdmin;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionCalculatorAdmin.tsx